<template>
  <section
    class="product js-color-change"
    data-logo-color="color"
    data-scroll-section
  >
    <MVBottom />

    <div class="skew top"></div>
    <div class="l-container">
      <div class="scroll">
        <span class="bar"></span>
      </div>

      <CSectionTitle>
        <template v-slot:titleEn>
          PRODUCT
        </template>
        <template v-slot:titleJa>
          商品紹介
        </template>
        <template v-slot:bg>
          <svg
            class="title-tri"
            width="356"
            height="290"
            viewBox="0 0 356 290"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g filter="url(#credit-title)">
              <path
                d="M302.316 63.7349L33.9698 104.832L13 231.116L302.316 63.7349Z"
                fill="white"
                opacity="0.1"
              />
            </g>

            <path
              d="M302.316 63.7349L33.9698 104.832L13 231.116L302.316 63.7349Z"
              fill="white"
            />
            <filter id="credit-title">
              <feGaussianBlur
                in="SourceAlpha"
                stdDeviation="8"
              ></feGaussianBlur>
              <feOffset dx="8" dy="8" />
            </filter>
          </svg>
        </template>
      </CSectionTitle>

      <div id="intro" class="intro__container">
        <div class="intro__col">
          <picture>
            <source type="image/webp" srcset="@/assets/bottle.webp" />
            <img ref="bottle" class="bottle" src="@/assets/bottle.png" alt="" />
          </picture>

          <div v-if="!isMobile" class="button-wrap">
            <c-button
              class="button button--pc"
              :isShopButton="true"
              scroll-speed="-0.5"
              :onClick="onLinkClick"
            />
          </div>
        </div>
        <div class="intro__col">
          <h3 ref="copy" class="intro__col__copy">
            一度決めた立ち上がりを崩さず、<br />
            ハードな立体感を演出
          </h3>
          <div class="intro__col__body">
            <div class="intro__rate-container">
              <div class="intro__rate-item">
                <span>セット力</span>
                <p>★★★★★★</p>
              </div>
              <div class="intro__rate-item">
                <span>ツヤ感</span>
                <p>★★★★☆</p>
              </div>
              <div class="intro__rate-item">
                <span>操作性</span>
                <p>★★★★☆</p>
              </div>
              <div class="intro__rate-item">
                <span>束感</span>
                <p>★★★★★★</p>
              </div>
            </div>
            <div class="intro__mapping-container">
              <img src="@/assets/mapping.jpg" alt="" />
              <p>オーシャントリコ ヘアスタイリング ワックスマッピング</p>
            </div>
            <c-button
              v-if="isMobile"
              :isShopButton="true"
              class="button button--sp"
              scroll-speed="0"
              :onClick="onLinkClick"
            />
          </div>
        </div>
        <div class="intro__product-name-wrap">
          <h3
            data-scroll
            data-scroll-direction="horizontal"
            data-scroll-speed="9"
            data-scroll-delay="0.05"
            data-scroll-target="#intro"
            class="intro__product-name"
          >
            TRICO JET
          </h3>
        </div>
      </div>

      <Feature />
    </div>

    <svg
      class="product-tri tri-01"
      width="656"
      height="490"
      viewBox="0 0 656 490"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#product-tri-01)">
        <path
          d="M632 18.0906L42.7261 173.21L26 459.091L632 18.0906Z"
          fill="white"
          opacity="0.1"
        />
      </g>
      <path
        d="M632 18.0906L42.7261 173.21L26 459.091L632 18.0906Z"
        fill="white"
      />
      <g filter="url(#product-tri-01)">
        <path
          d="M302.316 63.7349L33.9698 104.832L13 231.116L302.316 63.7349Z"
          fill="white"
          opacity="0.1"
        />
      </g>

      <path
        d="M302.316 63.7349L33.9698 104.832L13 231.116L302.316 63.7349Z"
        fill="white"
      />
      <filter id="product-tri-01">
        <feGaussianBlur in="SourceAlpha" stdDeviation="8"></feGaussianBlur>
        <feOffset dx="8" dy="8" />
      </filter>
    </svg>

    <svg
      class="product-tri tri-02"
      width="699"
      height="317"
      viewBox="0 0 699 317"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#product-tri-02)">
        <path
          d="M24 250.725L556.084 271.456L643.471 36.0593L24 250.725Z"
          fill="white"
          opacity="0.1"
        />
      </g>
      <path
        d="M24 250.725L556.084 271.456L643.471 36.0593L24 250.725Z"
        fill="white"
      />
      <g filter="url(#product-tri-02)">
        <path
          d="M205 288.497L608.674 304.225L674.971 125.638L205 288.497Z"
          fill="white"
          opacity="0.1"
        />
      </g>

      <path
        d="M205 288.497L608.674 304.225L674.971 125.638L205 288.497Z"
        fill="white"
      />
      <filter id="product-tri-02">
        <feGaussianBlur in="SourceAlpha" stdDeviation="20"></feGaussianBlur>
        <feOffset dx="-8" dy="-4" />
      </filter>
    </svg>

    <div class="skew bottom"></div>
  </section>
</template>

<script>
import { mapState } from 'vuex'

import MVBottom from '@/components/MVBottom.vue'
import Feature from '@/components/Feature.vue'

import CButton from '@/components/C-Button.vue'
import CSectionTitle from '@/components/C-SectionTitle.vue'

import 'splitting/dist/splitting.css'
import 'splitting/dist/splitting-cells.css'
import Splitting from 'splitting'
import gsap from 'gsap'

/* mixin */
import scrollTrigger from '@/mixins/scrollTrigger.js'

export default {
  mixins: [scrollTrigger],

  components: { MVBottom, Feature, CSectionTitle, CButton },

  computed: {
    ...mapState(['isMobile'])
  },

  async mounted() {
    const copy = this.$refs.copy
    await Splitting({
      target: copy,
      by: 'chars'
    })

    const tl = gsap.timeline({ paused: true })
    tl.add(function() {
      copy.classList.add('in-view')
    })
    tl.to(copy.querySelectorAll('.char'), {
      y: 0,
      duration: 0.8,
      stagger: 0.014,
      delay: 0.05,
      ease: 'Power3.easeOut'
    })

    const observer = new IntersectionObserver(
      (entries, observer) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            tl.play()
            observer.unobserve(entry.target)
          }
        })
      },
      { threshold: 1.0 }
    )

    observer.observe(copy)
  },

  methods: {
    onLinkClick() {
      window.location.href = 'https://oceantrico.com/product/jet'
    }
  }
}
</script>

<style lang="scss" scoped>
.product {
  position: relative;
  margin: 0 0 20rem;
  background-color: #fff;
  z-index: 0;
  @media screen and (max-width: $breakpoint-mobile) {
    padding: 5rem 0 0;
    margin: 0 0 5rem;
  }

  .c-section-title {
    .title-tri {
      position: absolute;
      top: -30rem;
      left: -25rem;
      width: 80rem;
      height: 80rem;
      z-index: -9;
      @media screen and (max-width: $breakpoint-mobile) {
        top: -9rem;
      }
    }
  }

  .intro {
    &__container {
      position: relative;
      display: flex;
      align-items: center;
      z-index: 0;

      @media screen and (max-width: $breakpoint-mobile) {
        flex-direction: column;
      }
    }

    &__col {
      width: 50%;
      padding: 0 4rem;
      @media screen and (max-width: $breakpoint-mobile) {
        width: 100%;
        padding: 0;

        &:nth-child(1) {
          margin: 0 0 4rem;
        }
      }

      .bottle {
        @media screen and (max-width: $breakpoint-mobile) {
          width: 25rem;
        }
      }

      .button-wrap {
        margin: 4rem 0 0;
      }
      &__copy {
        font-size: 4rem;
        text-align: left;
        margin: 0 0 3rem;
        transform: skewY(-5deg);
        line-height: 1.65;
        white-space: nowrap;
        color: var(--main-color);
        @media screen and (max-width: $breakpoint-mobile) {
          font-size: 2.4rem;
        }

        ::v-deep .word {
          overflow: hidden;
        }

        ::v-deep .char {
          transform: translate3d(0%, 100%, 0);
        }
      }

      &__body {
        padding: 0 5rem;
        @media screen and (max-width: $breakpoint-mobile) {
          padding: 0;
        }
      }
    }

    &__rate-container {
      display: flex;
      flex-wrap: wrap;
      background: #ffffff;
      box-shadow: 0px 0px 24px rgba(0, 0, 0, 0.09);
      margin: 0 0 3rem;
      color: var(--main-color);
    }

    &__rate-item {
      width: 50%;
      text-align: left;
      padding: 1.6rem 2.4rem;

      span {
        display: inline-block;
        padding: 0 0 0.5rem;
        font-size: 1.2rem;
        font-weight: 600;
        line-height: 1;
      }

      p {
        font-size: 1.8rem;
        font-weight: 800;
      }
    }

    &__mapping-container {
      font-size: 1.5rem;
      p {
        padding: 1rem;
      }

      img {
        max-width: 100%;
      }
    }
    &__product-name-wrap {
      position: absolute;
      top: 0;
      left: 0;
      transform: translate3d(0, 4.5rem, 0) skewY(-8deg);
      z-index: -9;
    }

    &__product-name {
      font-size: 30rem;
      white-space: nowrap;
      opacity: 0.08;
      color: var(--main-color);
    }
  }

  .skew {
    position: relative;
    width: 100%;
    height: 20vw;
    transform: translate(0px, 5rem);

    &.top {
      position: absolute;
      top: -6vw;
      z-index: -9;
    }

    &.bottom {
      position: absolute;
      bottom: -4vw;
      z-index: -9;
      @media screen and (max-width: $breakpoint-mobile) {
        bottom: 0;
      }
    }

    &:before {
      position: absolute;
      top: 0;
      left: 0;
      display: block;
      content: '';
      width: 100%;
      height: 100%;
      transform: skew(0deg, -6deg);
      background: #fff;
    }
  }

  .product-tri {
    position: absolute;
    z-index: -1;
    &.tri-01 {
      left: -12rem;
      bottom: -50rem;
      @media screen and (max-width: $breakpoint-mobile) {
        width: 38rem;
        left: -10rem;
        bottom: -32rem;
      }
    }
    &.tri-02 {
      right: -12rem;
      bottom: -15rem;
      @media screen and (max-width: $breakpoint-mobile) {
        right: -12rem;
        bottom: -19rem;
        width: 30rem;
      }
    }
  }
}
</style>
